const H = {
  name: "Grid",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 2H22V22H2V2ZM14 20V16H10V20H14ZM16 14H20V10H16V14ZM14 14V10H10V14H14ZM16 20H20V16H16V20ZM8 16H4V20H8V16ZM4 14H8V10H4V14ZM20 4H16V8H20V4ZM14 4H10V8H14V4ZM8 8V4H4V8H8Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as Grid
};
